import { ContentLink } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import {
  BlockContainer,
  TechnicalMessageList,
  TechnicalMessageListFilters,
  TechnicalMessageProvider,
  Title,
} from '@components';
import { useAppSelector, useAuth } from '@hooks';
import CreateIcon from '@mui/icons-material/Create';
import { Button, Stack } from '@mui/material';
import { getSpecialPage } from '@store/app/app.slice';
import { t } from '@translations';

type TechnicalMessageListBlockProps = {
  contentLink?: ContentLink;
  numberItemsOnPage?: number;
  title?: string;
};

export const TechnicalMessageListBlock = ({
  contentLink,
  numberItemsOnPage,
  title,
}: TechnicalMessageListBlockProps) => {
  const id = contentLink?.id?.toString() || '';
  const technicalMessagePage = useAppSelector(getSpecialPage('technicalMessageCreatePage'));
  const { isBeremaUser } = useAuth();
  return (
    <TechnicalMessageProvider id={id} numberItemsOnPage={numberItemsOnPage}>
      <BlockContainer>
        <div className='technical-list-block'>
          <Stack
            justifyContent={title ? 'space-between' : 'flex-end'}
            alignItems='center'
            flexWrap='wrap'
            direction='row'
          >
            {title && <Title variant='h2'>{title}</Title>}
            {technicalMessagePage && isBeremaUser && (
              <Button href={technicalMessagePage} variant='secondary' startIcon={<CreateIcon />}>
                {t(TextCodes.TechnicalMessage.Block.CreateNewMessage)}
              </Button>
            )}
          </Stack>
          <TechnicalMessageListFilters />
          <TechnicalMessageList />
        </div>
      </BlockContainer>
    </TechnicalMessageProvider>
  );
};
